import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import 'amfe-flexible/index'
import {setCookie,getCookie,delCookie} from '@/assets/cookie'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}
import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
// 按需引入elementUI组件
import './utils/elementComponent'
// 按需引入vantUI组件
import './utils/vantComponent'
// Element 额外提供了一系列类名，用于在某些条件下隐藏元素。
import 'element-ui/lib/theme-chalk/display.css';
import './assets/common.css'
import * as API from '@/utils/api'
// 将包含所有接口请求函数的对象保存到Vue原型对象
Vue.prototype.$API = API 
Vue.prototype.moment = moment
Vue.prototype.$store = store
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
